import { blueColor, goldColor } from "../../../../styled/Theme";

export const testimonialData = [
  {
    text: "OnePayX has completely simplified our payment process. Transactions that used to take days now happen in minutes. Truly a game changer!",
    name: "Alice Namirembe",
    division: "Finance Department",
    initials: "AN",
    color: blueColor,
  },
  {
    text: "The dashboard is so intuitive and easy to use. I can now reconcile payments and track transactions without wasting hours.",
    name: "John Mugisha",
    division: "Operations",
    initials: "JM",
    color: "#0ea5e9",
  },
  {
    text: "I love how OnePayX integrates with our existing systems. Making and receiving payments has never been this seamless.",
    name: "Sarah Kaggwa",
    division: "Accounting",
    initials: "SK",
    color: goldColor,
  },
  {
    text: "The support team is fantastic. Whenever I had an issue, it was resolved immediately. This platform makes our work stress-free.",
    name: "David Ochieng",
    division: "Finance",
    initials: "DO",
    color: "#22c55e",
  },
  {
    text: "With OnePayX, I no longer worry about delayed payments. The system is fast, reliable, and secure. Highly recommended!",
    name: "Esther Tumusiime",
    division: "Business Development",
    initials: "ET",
    color: "#a855f7",
  },
  {
    text: "OnePayX has improved our cash flow visibility significantly. I can now make informed decisions in real-time.",
    name: "Michael Ssenyonjo",
    division: "Management",
    initials: "MS",
    color: "#f97316",
  },
];
